import { render } from "./CountryDetails.vue?vue&type=template&id=17f2f4dc&ts=true"
import script from "./CountryDetails.vue?vue&type=script&lang=ts"
export * from "./CountryDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__